import React, { Component } from "react";

class About extends Component {
  render() {
    const { resumeBasicInfo } = this.props;
    const about = resumeBasicInfo?.description || "";
    const ui = resumeBasicInfo?.ui || {};

    return (
      <section id="about">
        <div className="about-grid">
          <div>
            <p className="sec-eye rv">{ui.about_eyebrow || "My Background"}</p>
            <h2 className="about-big rv" style={{ transitionDelay: ".05s" }}>
              {ui.about_line1 || "MY NAME IS"}
              <br />
              {ui.about_line2 || "JARED FLORES,"}
              <br />
              <span>{ui.about_line3 || "GAME DEVELOPER."}</span>
            </h2>
            <div className="about-body rv" style={{ transitionDelay: ".1s" }}>
              <p>{about}</p>
              <div className="currently">
                <div className="c-dot"></div>
                <p className="c-text">
                  <strong>{ui.about_available || "Currently available"}</strong>{" "}
                  {ui.about_available_suffix || "for freelance — if you're building something ambitious, let's talk."}
                </p>
              </div>
            </div>
          </div>

          <div className="about-sidebar rv" style={{ transitionDelay: ".15s" }}>
            <div className="holo-card">
              <div className="holo-rainbow"></div>
              <div className="holo-glare"></div>
              <img
                src={`${process.env.PUBLIC_URL}/images/Jared.png`}
                alt="Jared Flores"
                className="holo-img"
              />
            </div>
            <div className="sidebar-links">
              <a
                href="https://github.com/JaredFG"
                target="_blank"
                rel="noopener noreferrer"
                className="s-link"
              >
                <svg viewBox="0 0 24 24">
                  <path d="M12 0C5.37 0 0 5.37 0 12c0 5.3 3.44 9.8 8.2 11.38.6.11.82-.26.82-.58v-2.03c-3.34.73-4.04-1.61-4.04-1.61-.55-1.39-1.34-1.76-1.34-1.76-1.09-.74.08-.73.08-.73 1.2.09 1.84 1.24 1.84 1.24 1.07 1.83 2.8 1.3 3.49 1 .11-.78.42-1.3.76-1.6-2.67-.3-5.47-1.33-5.47-5.93 0-1.31.47-2.38 1.24-3.22-.13-.3-.54-1.52.12-3.18 0 0 1.01-.32 3.3 1.23a11.5 11.5 0 0 1 3-.4c1.02 0 2.04.14 3 .4 2.28-1.55 3.29-1.23 3.29-1.23.66 1.66.25 2.88.12 3.18.77.84 1.24 1.91 1.24 3.22 0 4.61-2.81 5.63-5.48 5.92.43.37.81 1.1.81 2.22v3.29c0 .32.21.7.82.58C20.56 21.8 24 17.3 24 12c0-6.63-5.37-12-12-12z" />
                </svg>
                GitHub
              </a>
              <a
                href="https://jaredfg.itch.io"
                target="_blank"
                rel="noopener noreferrer"
                className="s-link"
              >
                <svg viewBox="0 0 24 24">
                  <path d="M3.13 1.06C2.04 1.7.05 4.2 0 6v1c0 1.5.79 2.82 2 3.57v9.43A2 2 0 0 0 4 22h16a2 2 0 0 0 2-2V10.57C23.21 9.82 24 8.5 24 7V6c-.05-1.8-2.04-4.3-3.13-4.94C19.47.54 13.4 0 12 0 10.6 0 4.53.54 3.13 1.06zM12 2c2.18 0 7.65.4 8.83 1.08.66.38 1.7 1.64 2.1 2.72.07.2.07.4 0 .6C22.47 7.5 21.25 8 20 8c-1.37 0-2.62-.7-3.34-1.76C16.1 7.3 14.13 8 12 8c-2.13 0-4.1-.7-4.66-1.76C6.62 7.3 5.37 8 4 8c-1.25 0-2.47-.5-2.93-1.6a1.5 1.5 0 0 1 0-.6c.4-1.08 1.44-2.34 2.1-2.72C4.35 2.4 9.82 2 12 2z" />
                </svg>
                Itch.io
              </a>
              <a
                href="https://www.linkedin.com/in/jared-abraham-flores-guarneros-5515a0191/"
                target="_blank"
                rel="noopener noreferrer"
                className="s-link"
              >
                <svg viewBox="0 0 24 24">
                  <path d="M20.45 20.45h-3.55v-5.57c0-1.33-.03-3.04-1.85-3.04-1.85 0-2.13 1.45-2.13 2.94v5.67H9.37V9h3.41v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.45v6.29zM5.34 7.43a2.06 2.06 0 1 1 0-4.12 2.06 2.06 0 0 1 0 4.12zm1.78 13.02H3.56V9h3.56v11.45zM22.22 0H1.77C.79 0 0 .77 0 1.73v20.54C0 23.23.79 24 1.77 24h20.45c.98 0 1.78-.77 1.78-1.73V1.73C24 .77 23.2 0 22.22 0z" />
                </svg>
                LinkedIn
              </a>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default About;
